import { apiClient } from "../apiClient"
import { apiConnector } from "../apiConnector"
import toast from "react-hot-toast"
import {setHolidays} from '../../slices/holidayslist'
import {setLeaves} from '../../slices/leaves'
import {setNotification} from '../../slices/notification'

// Helper to get role
const getRole = () => {
    const user = localStorage.getItem('user')
    const userData = user ? JSON.parse(user) : null
    return userData?.role
}


export function Get_HolidaysList(token) {
    return async (dispatch) => {
        try {
            const response = await apiConnector("GET", apiClient.GET_HOLIDAYSLIST,null,{Authorization:`Bearer ${token}`});

            if (!response?.data?.success) {
                throw new Error(response?.data?.message);
            }
            toast.success(response?.data?.message)
            dispatch(setHolidays(response?.data?.data))
            return response;

        } catch (error) {
            const message = error.response?.data?.message || error?.message;
            console.log("Internal Client Error:", message);
            return error?.response;
        }
    };
}
export function Post_HolidaysList(formData,token) {
    return async (dispatch) => {
        try {
            const response = await apiConnector("POST", apiClient.POST_HOLIDAYSLIST, formData,{Authorization:`Bearer ${token}`});

            if (!response?.data?.success) {
                throw new Error(response?.data?.message);
            }

            toast.success(response?.data?.message);
            dispatch(Get_HolidaysList(token))
            return response;

        } catch (error) {
            const message = error.response?.data?.message || error?.message;
            console.log("Internal Client Error:", message);
            return error?.response;
        }
    };
}

export function Update_HolidaysList(id, formData,token) {
    return async (dispatch) => {
        try {
            const response = await apiConnector(
                "PUT",
                `${apiClient.PUT_HOLIDAYSLIST}/${id}`,
                formData,
                {Authorization:`Bearer ${token}`}
            );

            if (!response?.data?.success) {
                throw new Error(response?.data?.message);
            }

            toast.success(response?.data?.message);
            dispatch(Get_HolidaysList(token))
            return response;

        } catch (error) {
            const message = error.response?.data?.message || error?.message;
            console.log("Internal Client Error:", message);
            return error?.response;
        }
    };
}

export function Delete_HolidaysList(id,token) {
    return async (dispatch) => {
        try {
            const response = await apiConnector("DELETE",`${apiClient.DELETE_HOLIDAYSLIST}/${id}`,null,{
                Authorization:`Bearer ${token}`
            }
            );

            if (!response?.data?.success) {
                throw new Error(response?.data?.message);
            }

            toast.success(response?.data?.message);
            dispatch(Get_HolidaysList(token))
            return response;

        } catch (error) {
            const message = error.response?.data?.message || error?.message;
            console.log("Internal Client Error:", message);
            return error?.response;
        }
    };
}

export function Get_Leaves(token) {
    return async (dispatch) => {
        try {
            const response = await apiConnector("GET", apiClient.GET_LEAVES,null,{
                Authorization:`Bearer ${token}`
            });

            if (!response?.data?.success) {
                throw new Error(response?.data?.message);
            }
            toast.success(response?.data?.message)
            dispatch(setLeaves(response?.data?.data))
            return response;

        } catch (error) {
            const message = error.response?.data?.message || error?.message;
            console.log("Internal Client Error:", message);
            return error?.response;
        }
    };
}
export function Approve_Leave(formData,token) {
    return async (dispatch) => {
        try {
            const response = await apiConnector("POST",apiClient.APPROVED_LEAVE,formData,{
                Authorization:`Bearer ${token}`
            });

            if (!response?.data?.success) {
                throw new Error(response?.data?.message);
            }

            toast.success(response?.data?.message);
            dispatch(Get_Leaves(token))
            return response;

        } catch (error) {
            const message = error.response?.data?.message || error?.message;
            console.log("Internal Client Error:", message);
            return error?.response;
        }
    };
}
export function Delete_Leave(leaveId,token) {
    return async (dispatch) => {
        try {
            const response = await apiConnector("DELETE",apiClient.DELETE_LEAVES+`/${leaveId}`,null,{
                Authorization:`Bearer ${token}`
            });

            if (!response?.data?.success) {
                throw new Error(response?.data?.message);
            }

            toast.success(response?.data?.message);
            dispatch(Get_Leaves(token))
            return response;

        } catch (error) {
            const message = error.response?.data?.message || error?.message;
            console.log("Internal Client Error:", message);
            return error?.response;
        }
    };
}


/* ================== Notification Bussiness Logic ============== */
export function Get_Notification(token) {
    return async (dispatch) => {
        try {
            const response = await apiConnector(
                "GET",
                apiClient.GET_NOTIFICATION,
                null,
                {
                    Authorization: `Bearer ${token}`
                }
            );

            if (!response?.data?.success) {
                throw new Error(response?.data?.message);
            }
            dispatch(setNotification(response?.data?.data))

            return response;

        } catch (error) {
            const message = error.response?.data?.message || error?.message;
            console.log("Internal Client Error:", message);
            return error?.response;
        }
    };
}
export function Delete_Notification(id, token) {
    return async (dispatch) => {
        try {
            const response = await apiConnector(
                "DELETE",
                apiClient.DELETE_NOTIFICATION.replace(":id", id),
                null,
                {
                    Authorization: `Bearer ${token}`
                }
            );

            if (!response?.data?.success) {
                throw new Error(response?.data?.message);
            }

            toast.success(response?.data?.message);

            // Refresh list
            dispatch(Get_Notification(token));

            return response;

        } catch (error) {
            const message = error.response?.data?.message || error?.message;
            console.log("Internal Client Error:", message);
            return error?.response;
        }
    };
}
export function Read_Notification(id, token) {
    return async (dispatch) => {
        try {
            const response = await apiConnector(
                "PUT",
                apiClient.READMARK_NOTIFICATION.replace(":id", id),
                null,
                {
                    Authorization: `Bearer ${token}`
                }
            );

            if (!response?.data?.success) {
                throw new Error(response?.data?.message);
            }

            // Optional toast
            // toast.success(response?.data?.message);

            dispatch(Get_Notification(token));

            return response;

        } catch (error) {
            const message = error.response?.data?.message || error?.message;
            console.log("Internal Client Error:", message);
            return error?.response;
        }
    };
}
export function ReadAll_Notification(token) {
    return async (dispatch) => {
        try {
            const response = await apiConnector(
                "PUT",
                apiClient.READMARKALL_NOTIFICATION,
                null,
                {
                    Authorization: `Bearer ${token}`
                }
            );

            if (!response?.data?.success) {
                throw new Error(response?.data?.message);
            }

            toast.success(response?.data?.message);

            dispatch(Get_Notification(token));

            return response;

        } catch (error) {
            const message = error.response?.data?.message || error?.message;
            console.log("Internal Client Error:", message);
            return error?.response;
        }
    };
}
export function UnReadcount_Notification(token) {
    return async (dispatch) => {
        try {
            const response = await apiConnector(
                "GET",
                apiClient.UNREADCOUNT_NOTIFICATION,
                null,
                {
                    Authorization: `Bearer ${token}`
                }
            );

            if (!response?.data?.success) {
                throw new Error(response?.data?.message);
            }

            toast.success(response?.data?.message);
            return response;

        } catch (error) {
            const message = error.response?.data?.message || error?.message;
            console.log("Internal Client Error:", message);
            return error?.response;
        }
    };
}

// Get software plan payments
export function GetSoftwarePlan(token) {
  return async (dispatch) => {
    try {
      const res = await apiConnector("GET", apiClient.GET_SOFTWARE_PLAN, null, {
        Authorization: `Bearer ${token}`,
      });
       console.log("GetSoftwarePlan Response:", res);
      if (!res?.data?.success) {
        throw new Error(res?.data?.message);
      }
      // TODO: Dispatch to a slice if needed
      toast.success(res?.data?.message);
      return res?.data?.data;
    } catch (error) {
      const message = error?.response?.data?.message;
      console.log("GetSoftwarePlan Error:", error);
      toast.error(message || "Failed to fetch software payments");
    }
  };
}
// Get hardware plan 
export function GetHardwarePlan(token) {
  return async (dispatch) => {
    try {
      // Add query param ?limit=100
      const url = apiClient.GET_HARDWARE_PLAN;
      const res = await apiConnector("GET", url, null, {
        Authorization: `Bearer ${token}`,
      });
    //   console.log("GetHardwarePlan Response:", res);
      if (!res?.data?.success) throw new Error(res?.data?.message);
      
      let payments = res?.data?.data;
      if (payments && !Array.isArray(payments) && payments.payments) {
        payments = payments.payments;
      }
      toast.success(res?.data?.message);
      return payments || [];
    } catch (error) {
      console.error("GetHardwarePlan Error:", error);
      toast.error(error?.response?.data?.message || "Failed to fetch hardware payments");
      return [];
    }
  };
}

//GIVE MANAGER ACCESS
export function GiveManagerAccess(managerId, access, token) {
    console.log("managerID",managerId, "access", access, "token", token)
    if (access !== true) console.log("Invalid Field")
    return async (dispatch) => {
        try {
            const response = await apiConnector(
                "POST",
                apiClient.GIVE_MANAGER_ACCESS_ORG+`/${managerId}`,
                { access: access }, 
                { Authorization: `Bearer ${token}` }
            );
            console.log("url...",apiClient.GIVE_MANAGER_ACCESS_ORG+`/${managerId}`);
            console.log("response", response)
            if (!response?.data?.success) {
                throw new Error(response?.data?.message);
            }

            toast.success(response?.data?.message);
            return response;

        } catch (error) {
            const message = error.response?.data?.message || error?.message;
            console.log("Internal Client Error:", message);
            toast.error(message || "Failed to update manager access");
            return error?.response;
        }
    };
}

// Get hardware plan 
export function GetWalletTracking() {
  const token = localStorage.getItem('token');  
  const role = getRole();
  return async (dispatch) => {
    try {
      // Add query param ?limit=100
      const url = role === 'Organization'
      ? apiClient.WALLET_TRACKING_ORG
      : apiClient.WALLET_TRACKING_MNG
      const res = await apiConnector("GET", url, null, {
        Authorization: `Bearer ${token}`,
      });
    //   console.log("GetHardwarePlan Response:", res);
      if (!res?.data?.success) throw new Error(res?.data?.message);
      toast.success(res?.data?.message);
      return res
    } catch (error) {
      console.error("GetWalletTracking:", error);
      toast.error(error?.response?.data?.message);
      return error.res;
    }
  };
}